import FileRequestsAnnouncement from '@/components/announcements/FileRequestsAnnouncement';
import CutsEditorAnnouncement from '@/components/announcements/CutsEditorAnnouncement';
import CutsAdminAnnouncement from '@/components/announcements/CutsAdminAnnouncement';
import FootagePullAnnouncement from '@/components/announcements/FootagePullAnnouncement';
import FootagePullAdminAnnouncement from '@/components/announcements/FootagePullAdminAnnouncement';
import FootagePull29Announcement from '@/components/announcements/FootagePull29Announcement';
import SongOnceEditorAnnouncement from '@/components/announcements/SongOnceEditorAnnouncement';
import SongOnceAdminAnnouncement from '@/components/announcements/SongOnceAdminAnnouncement';
import SongOnceClientAnnouncement from '@/components/announcements/SongOnceClientAnnouncement';
import ReferralProgramAnnouncement from '@/components/announcements/ReferralProgramAnnouncement';
import SamplesPerProductAnnouncement from '@/components/announcements/SamplesPerProductAnnouncement';
import { DocEditNotesAnnouncement } from '@/components/announcements/DocEditNotesAnnouncement';
import PreparedProjectsAnnouncement from '@/components/announcements/PreparedProjectsAnnouncement';
import RoughEditStaysAnnouncement from '@/components/announcements/RoughEditStaysAnnouncement';
import PreparedFeedbackAnnouncement from '@/components/announcements/PreparedFeedbackAnnouncement';

/**
 * Announcement registry — key to component.
 *
 * ORDER LIVES ON THE SERVER, not here. `GET /announcements/pending` returns the
 * keys a user is owed in queue order (declaration order in routes/announcements.py),
 * and this map only says what to render for a key. Two orderings would be two
 * things to keep in step.
 *
 * PROMPTS ARE NOT ANNOUNCEMENTS, and the distinction is load-bearing.
 *
 *   An ANNOUNCEMENT tells someone the product changed. It is one-time, it is
 *   acknowledged per user, and it is optional to the person's work — nobody is
 *   blocked by not having read it. Two in one login reads as neglect, so the rule
 *   is ONE announcement per login even when a user is owed several.
 *
 *   A PROMPT asks someone for something the product needs from them right now.
 *   It recurs until answered (the editor time survey is the live one, EditorTimeSurvey.js;
 *   the footage-intake question was one, retired 2026-09-16). It is NOT subject to
 *   the one-per-login rule and must never be suppressed by it — an announcement
 *   deferring a prompt would trade a nice-to-know for a needed answer.
 *
 * The queue therefore orders announcements AMONG THEMSELVES and waits behind
 * prompts, rather than competing with them. Wiring is Phase 2; this file
 * currently only resolves a key to a component.
 */
export const ANNOUNCEMENT_COMPONENTS = {
  file_requests: FileRequestsAnnouncement,
  cuts_editor: CutsEditorAnnouncement,
  cuts_admin: CutsAdminAnnouncement,
  footage_pull: FootagePullAnnouncement,
  footage_pull_admin: FootagePullAdminAnnouncement,
  footage_pull_29: FootagePull29Announcement,
  song_once_editor: SongOnceEditorAnnouncement,
  song_once_admin: SongOnceAdminAnnouncement,
  song_once_client: SongOnceClientAnnouncement,
  referral_program: ReferralProgramAnnouncement,
  samples_per_product: SamplesPerProductAnnouncement,
  doc_edit_notes: DocEditNotesAnnouncement,
  prepared_projects: PreparedProjectsAnnouncement,
  rough_edit_stays: RoughEditStaysAnnouncement,
  prepared_feedback: PreparedFeedbackAnnouncement,
};

/** First pending key that this build knows how to render.
 *  A key with no component here is skipped rather than crashing — a server that
 *  has been deployed ahead of the frontend must not blank the dashboard. */
export function firstRenderable(pending) {
  return (pending || []).find(k => ANNOUNCEMENT_COMPONENTS[k]) || null;
}

export default ANNOUNCEMENT_COMPONENTS;
